import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';

import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';

import {Subject, Subscription} from 'rxjs';
import {UserStore} from '../../../authentication/state/user.store';
import {EntryType, QuestionType, RouterLinks} from '../../../shared/constants';

import {debounceTime} from 'rxjs/operators';
import {QuestionFlowSessionStore} from '../../../shared/questions/state/question-flow-session.store';
import { forEach } from 'lodash';

declare const accounting: any;
declare const $: any;

declare function notify(): any;

declare function editModalGuides(): any;

enum DisplayItem {
  PolicyHolderDetails = 'PolicyHolderDetails',
  PaymentDetails = 'PaymentDetails',
  ClassItems = 'ClassItems',
  BenefitItems = 'BenefitItems'
}

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-commercial-edit',
    templateUrl: './commercial-edit.component.html',
    styleUrls: ['./commercial-edit.component.scss'],
    standalone: false
})
export class CommercialEditComponent implements OnInit, AfterViewInit, OnDestroy {


  newPolicies: any[] = [];
  newPolicy: any;
  fees = '';
  accounting: any;
  person: any;
  getPolicySubscription: Subscription;
  tempPolicyId = '';
  tempPolicySessionId = '';
  newPolicySessionId = '';
  showDetail = '';
  displayItems = DisplayItem;
  activeItemId = '';
  activeClassId: number;
  activeBenefitClassId: number;
  notify: any;
  Entities = Entity;
  selectedEntity = '';
  filterByClass: any;
  filterByType = 'all';
  frequency_id: number;
  currentDate = new Date();
  question: any;
  lottieOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  questionChanged = new Subject<any>();
  selectedLocation: any;
  selectedClass: any;
  locations: any;
  classes: any;
 questions: any = [];
 grouping: any;
 nonlocation: any;
  constructor(
    
    private router: Router,
    private datePipe: DatePipe,
  
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private userStore: UserStore,
    public questionService: GlobalQuestionService) {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    this.notify = notify();
    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.locations = this.router.getCurrentNavigation()?.extras?.state?.locations;
      this.selectedLocation = this.router.getCurrentNavigation()?.extras?.state?.location;
      this.classes = this.router.getCurrentNavigation()?.extras?.state?.classes;
      this.grouping = this.router.getCurrentNavigation()?.extras?.state?.grouping;
      this.nonlocation = this.router.getCurrentNavigation()?.extras?.state?.nonlocation;
      this.setLocation(this.selectedLocation);
      console.log(this.nonlocation)
    }else{
      this.router.navigate([RouterLinks.QuestionFlow])
    }
  }

  ngOnInit(): void {
    this.person = this.userStore.getValue();
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
    // setTimeout(() => {
    //   editModalGuides()?.init('#edit-entire-couch', 1);
    //   this.notify.init({
    //     message: '<strong>Please note:</strong> We will process the changes to your cover once you click the Update Policy button below.', // required
    //     icon: 'warning',   // default: null; options: 'info', 'complete', or any icon-name really
    //     size: 'lg',     // default: null; options: 'lg'
    //     style: 'info',  // default: null; options: 'info', 'success',
    //     close: true,    // default: false (close button enabled, auto-close duration removed)
    //     speed: 350,     // default: 350 (fade in/out speed)
    //     duration: 5000  // default: 5000 (duration active)
    //   });
    // }, 100);
  }

  getPolicy(): void {

    
  }

  

  setItemIdClassId(item_id: any, class_id: number): void {
    setTimeout(() => {
      this.activeClassId = class_id;
      this.activeItemId = item_id;
    }, 100);
  }

  changeDisplayItem(item: string): void {
    this.showDetail = item;
  }

  scrollToItem(section: string): void {
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView(true);
      el.scrollIntoView({behavior: 'smooth'});
      const scrolledY = window.scrollY;
      if (scrolledY) {
        window.scroll({
          top: scrolledY - 80,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }
 setLocation(location: any, class_: any = null): void {

  this.selectedLocation = location;
  this.selectedClass = class_;
  let class_id = 0;
  if (this.selectedClass){
     class_id = this.selectedClass?.class_id;
  }
  console.log(this.selectedLocation, this.selectedClass)
  this.questionService.spinner(true);
  this.questionService.getResponses()
      .subscribe(r => {
        this.questions = [];
        if (r?.length == 0){
          return;
        }
        r.forEach(q => {
          if (class_id > 0){
            if (q?.location_id === this.selectedLocation?.location_id && q?.product_class_id === class_id){
              this.questions.push(q)
            }
          }
          else{
            if (q?.location_id === this.selectedLocation?.location_id){
              this.questions.push(q)
            }
          }
          
        });
       
        this.questionService.spinner(false);
       
      }, error => {
        this.questionService.spinner(false);
        
      });
 } 
 questionResponse(event): void {
 }
 getItemChildrenQuestions(question: any): any[] {
  //return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  return [];
}
getGroupingClasses(group: any, c: any): any {
  if (c) return this.classes.filter(g => g.group_id === group.group_id && g.group_id !==4 && g.parent_answer_id === c.cent_aq_answer_id);
 else return this.classes.filter(g => g.group_id === group.group_id && g.group_id !==4 && g?.level === 1);
}
  ngOnDestroy(): void {
    //this.getPolicySubscription.unsubscribe();
  }

}
